module.exports = __webpack_public_path__ + "img/la_costanera_restaurant.f87f123b.jpg";